"use client";
import { jsx as e } from "react/jsx-runtime";
import { useInkeepConfig as r } from "../../providers/config-provider.js";
import { BuiltInIconRenderer as u } from "./built-in-icon-renderer.js";
import { defaultBuiltInIcons as m } from "./inkeep-default-icons.js";
function p({ iconKey: t, ...o }) {
  const n = m[t], s = n ? { builtIn: n } : { custom: "" }, { baseSettings: c } = r(), i = c.customIcons?.[t] || s;
  return /* @__PURE__ */ e(
    u,
    {
      "data-icon": t,
      iconSettings: i,
      ...o
    }
  );
}
export {
  p as CustomIcon
};
